import React from 'react';
import styled from 'styled-components';
import Button, { WhiteButton } from '../../ITVActivation/Components/Button';
import CashSaverBrands from '../../ITVActivation/Components/CashSaverBrands';
import ActivationSteps from './ActivationSteps';
import { useTranslation } from 'react-i18next';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const ButtonsContainer = styled.div`
  padding-top: 30px;
  padding-inline: 24px;
  display: flex;
  flex-direction: column;
`;

const CashSaverMsg = styled.span`
  text-align: center;
  padding-inline: 50px;
  font-family: Arial;
  margin-top: 40px;
  font-size: 14px;
`;

const FaqLink = styled.span`
  display: block;
  font-family: Arial;
  padding-top: 24px;
  font-size: 14px;
  text-decoration: underline;
  text-align: center;
`;

interface ActivateNowProps {
  title?: string;
  msg?: string;
  steps?: string[];
  cashSaverPopUpMsg?: string;
  permissionsAgreed?: boolean;
  navigateToSettings?: () => void;
  close?: () => void;
}

const ActivateNow: React.FC<ActivateNowProps> = ({
  title,
  msg,
  steps,
  permissionsAgreed,
  navigateToSettings,
  cashSaverPopUpMsg,
  close,
}) => {
  const { t } = useTranslation();

  return (
    <Container>
      {permissionsAgreed ? (
        <>
          <CashSaverMsg>{cashSaverPopUpMsg}</CashSaverMsg>
          <CashSaverBrands />
        </>
      ) : (
        <ActivationSteps title={title} msg={msg} steps={steps} />
      )}

      <ButtonsContainer>
        {permissionsAgreed ? (
          <>
            <Button
              id="android-accessiblity-button-continue"
              className="itvTheme"
              height="42px"
              onClick={close}
            >
              {t('extension.itvActivation.androidAccessibility.continue')}
            </Button>
            <FaqLink>{t('extension.itvActivation.faq.faqLink')}</FaqLink>
          </>
        ) : (
          <>
            <Button
              id="android-accessiblity-button-agree"
              className="itvTheme"
              height="42px"
              onClick={navigateToSettings}
            >
              {t('extension.itvActivation.androidAccessibility.agree')}
            </Button>
            <WhiteButton
              onClick={close}
              id="android-accessiblity-button-disagree"
              className="itvTheme"
              height="42px"
              margin="10px 0 0 0"
            >
              {t('extension.itvActivation.androidAccessibility.disagree')}
            </WhiteButton>
          </>
        )}
      </ButtonsContainer>
    </Container>
  );
};

export default ActivateNow;
